<template>
  <div data-qa="appointment_call_time">
    <BannerInfo
      data-qa="appointment_call_time_alert"
      :inner-atom-indent="0"
    >
      <div
        class="text-body-2 text--text"
        data-qa="appointment_call_time_warning_text"
      >
        {{ $t('Для подтверждения записи вам позвонит администратор', options) }}
        <span class="text-no-wrap font-weight-medium">
          {{ selectedDate }} в
          <span
            id="timeSelectActivator"
            class="primary--text cursor-pointer"
          >{{ selectedTimeRange }}</span>
        </span>.
        {{ $t('Сейчас в клинике нерабочее время.', options) }}
      </div>
    </BannerInfo>
    <MenuBottomSheet
      v-model="isVisibleBottomSheet"
      activator="#timeSelectActivator"
      data-qa="appointment_call_time_bottom_sheet"
    >
      <v-list
        class="overflow-y-auto"
        :max-height="isMobile ? 392 : 240"
        :min-width="isMobile ? 0 : 320"
      >
        <v-list-item
          v-for="(time, index) in availableAppointmentCallTimes"
          :key="index"
          color="primary"
          :input-value="time.value === selectedAppointmentCallTime"
          @click="clickListItem(time.value)"
        >
          <v-list-item-content class="text-body-1 text--text">
            {{ time.text }}
          </v-list-item-content>
          <v-list-item-icon v-if="isMobile">
            <v-icon>
              ui-icon-arrow-right
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </MenuBottomSheet>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { mapState, mapActions } from 'pinia'
import { getDateFnsLocaleByIso } from 'www/utils'
import { useAppointmentDataStore } from 'www/vue_components/common/AppointmentPage/stores'
import BannerInfo from 'www/vue_components/common/core/BannerInfo.vue'
import MenuBottomSheet from 'www/vue_components/common/core/MenuBottomSheet.vue'

export default {
  name: 'AppointmentCallTime',
  components: {
    MenuBottomSheet,
    BannerInfo,
  },
  data: vm => ({
    isMobile: window.MOBILE_VERSION,
    isVisibleBottomSheet: false,
    options: { ns: vm.$i18next.language },
  }),
  computed: {
    ...mapState(useAppointmentDataStore, [
      'appointmentCallTimes',
      'selectedAppointmentCallTime',
    ]),
    ...mapState(useAppointmentDataStore, [
      'availableAppointmentCallTimes',
    ]),
    selectedDate() {
      return format(
        new Date(this.appointmentCallTimes.date),
        'd MMMM (EEEEEE)',
        { locale: getDateFnsLocaleByIso(this.$i18next.language) },
      )
    },
    selectedTimeRange() {
      const selectedAppointmentCallTimeObject = this.availableAppointmentCallTimes
        .find(time => time.value === this.selectedAppointmentCallTime) || {}

      return selectedAppointmentCallTimeObject.text
    },
  },
  watch: {
    availableAppointmentCallTimes: {
      immediate: true,
      handler(list) {
        if (!list || !list.length) {
          return
        }

        if (!this.selectedAppointmentCallTime) {
          this.updateSelectedAppointmentCallTime(list[0].value)
          return
        }

        const isAlreadyInArray = list.some(({ value }) => value === this.selectedAppointmentCallTime)

        if (!isAlreadyInArray) {
          this.updateSelectedAppointmentCallTime(list[0].value)
        }
      },
    },
  },
  methods: {
    ...mapActions(useAppointmentDataStore, [
      'updateSelectedAppointmentCallTime',
    ]),
    closeBottomSheet() {
      this.isVisibleBottomSheet = false
    },
    clickListItem(selectedAppointmentCallTime) {
      this.updateSelectedAppointmentCallTime(selectedAppointmentCallTime)
      this.closeBottomSheet()
    },
  },
}
</script>
